<template>
  <div class="tabs">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!--      <el-tab-pane disabled></el-tab-pane>-->
      <!--                <el-tab-pane label="판촉 정보" name="first" style="background-color: black">-->
      <el-tab-pane :label="$t('friends.promotioninfo')" name="first">
        <!-- <el-tab-pane label="Promotion information" name="first" style="background-color: black"> -->
        <div class="cardall">
          <el-card class="img1">
            <div class="img1-amount" v-if="userprofile?.wallet">${{ textFormat(userprofile.wallet, '#,##0.00') }}</div>
            <div class="img1-amount" v-else>$0</div>
            <div class="withdraw">
            <el-button type="primary" size="small" @click="toWithdrawal">{{$t('friends.withdraw')}}</el-button>
            </div>
          </el-card>
          <el-card class="img2">
            <div class="img2-title">
              <!--  Discount Codes-->
              <span class="img2-discount">{{$t('home.discountcode')}}</span>
            </div>
            <div class="img2-code">{{ userprofile.discountcode }}</div>
            <div class="img2-ratio">
              <template v-if="userprofile?.discode?.type == '1'">
                <span>{{ $t('friends.discountratio') }}</span>
                <span class="img2-discountratio">{{ userprofile?.discode?.discountratio * 100 }}%</span>
              </template>
              <template v-else>
                <span class="mr-2">{{ $t('friends.lowestdiscountratio') }}</span>
                <span v-if="userprofile?.discode">{{ userprofile?.discode?.discountratio * 100 }}%</span>
                <span v-else>0%</span>
              </template>
            </div>
          </el-card>
          <el-card class="img3">
            <barChart ref="barChart"/>
          </el-card>
        </div>
        <div class="friends-bottom">
          <el-card>
            <div class="friends-bottom-title">{{ $t('friends.orderdetails') }}</div>
            <promotionList ref="promotionList"/>
          </el-card>
          <el-card class="circle-pie">
            <div class="tr">
              <el-date-picker
                  v-model="dataForm.timeList"
                  class="mb-4 large"
                  type="daterange"
                  :clearable="false"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  range-separator="-"
                  @change="changeCirclePieTime"
                  start-placeholder=""
                  end-placeholder="">
              </el-date-picker>
              <div class="small">
                <smallVanDateRange ref="smallVanDateRange" @confirmDateRange="confirmDateRange"/>
              </div>
            </div>
            <circlePieChart ref="circlePieChart"/>
          </el-card>
        </div>
        <div class="total-amount">
          <!-- 销售总额 -->
          <div>Price：{{ amount.price }}</div>
          <!-- 收益 -->
          <div>Profit：{{ amount.profit }}</div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('friends.withdrawalsrecord')" name="second">
        <withdrawalsList ref="withdrawalsList"/>
      </el-tab-pane>
    </el-tabs>

    <el-dialog customClass="customWidth" title="Withdrawal application" :visible.sync="dialogFormVisible"
               :close-on-press-escape="false" :close-on-click-modal="false" :before-close="closeDialog">
      <el-form :model="form" :rules="rules" ref="ruleUser">
        <!--                    <el-form-item label='계정' prop='account' :label-width="formLabelWidth">-->
        <el-form-item :label="$t('friends.accounts')" prop='account' :label-width="formLabelWidth">
          <!-- <el-form-item label='Accounts' prop='account' :label-width="formLabelWidth"> -->
          <el-input placeholder='Please enter the receiving account' clearable autocomplete="off" v-model='form.account'
                    size="small"/>
        </el-form-item>
        <!--                    <el-form-item label='계정 유형' prop='type' :label-width="formLabelWidth">-->
        <el-form-item :label="$t('friends.accounttype')" prop='type' :label-width="formLabelWidth">
          <!-- <el-form-item label='Account type' prop='type' :label-width="formLabelWidth"> -->
          <el-select v-model="form.type" placeholder="please choose">
            <el-option v-for="item in accountTypeOptions" :key="item.value" :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item v-if="form.type == '1'" :label="$t('friends.bank')" prop='bank' :label-width="formLabelWidth"> -->
        <div v-if="form.type == '1'">
          <el-form-item label="수취인명(Beneficiary Name)" prop='name' :label-width="formLabelWidth">
            <el-input placeholder='Please enter the bank' clearable autocomplete="off" v-model='form.name'
                      size="small"/>
          </el-form-item>
          <el-form-item label="계좌번호(Beneficiary Account Number)" prop='number' :label-width="formLabelWidth">
            <el-input placeholder='Please enter the bank' clearable autocomplete="off" v-model='form.number'
                      size="small"/>
          </el-form-item>
          <el-form-item label="은행 영문명(Beneficiary Bank Name)" prop='bankname' :label-width="formLabelWidth">
            <el-input placeholder='Please enter the bank' clearable autocomplete="off" v-model='form.bankname'
                      size="small"/>
          </el-form-item>
          <el-form-item label=" SWIFT CODE (Beneficiary Bank Swift Code)" prop='swiftcode' :label-width="formLabelWidth">
            <el-input placeholder='Please enter the bank' clearable autocomplete="off" v-model='form.swiftcode'
                      size="small"/>
          </el-form-item>
          <el-form-item label="은행 영문주소(Beneficiary Bank Address) " prop='address' :label-width="formLabelWidth">
            <el-input placeholder='Please enter the bank' clearable autocomplete="off" v-model='form.address'
                      size="small"/>
          </el-form-item>
        </div>
        <el-form-item class="withdrawal-amount" :label="$t('friends.withdrawalamount')" prop='price' :label-width="formLabelWidth">
          <!--                    <el-form-item label='인출 금액.' prop='price' :label-width="formLabelWidth">-->
          <!-- <el-form-item label='Withdrawal Amount' prop='price' :label-width="formLabelWidth"> -->
          <el-input-number placeholder='Please enter the withdrawal amount' clearable autocomplete="off"
                           v-model='form.price' :precision="2" :step="0.1" :max="userprofile.wallet"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!--                    <el-button @click="closeDialog()">취소</el-button>-->
        <el-button @click="closeDialog()">{{ $t('friends.cancel') }}</el-button>
        <!-- <el-button @click="closeDialog()">Cancel</el-button> -->
        <!--                    <el-button type="primary" @click="submitUser">제출</el-button>-->
        <el-button type="primary" @click="submitUser">{{ $t('friends.submit') }}</el-button>
        <!-- <el-button type="primary" @click="submitUser">Submit</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getUserByid, insertWithdrawal,getkolStatisData} from "@/request/requests";
import {MessageError, MessageSuccess, getUserInfo,isEmpty} from "@/util/util"
import promotionList from "./friends/promotionList";
import withdrawalsList from "./friends/withdrawalsList";
import circlePieChart from "./friends/circlePieChart";
import barChart from "./friends/barChart";
import smallVanDateRange from "@/components/smallVanDateRange";
// import VueQr from 'vue-qr'
export default {
  components: {
    // VueQr,
    promotionList,
    withdrawalsList,
    circlePieChart,
    barChart,
    smallVanDateRange
  },
  name: "friends",
  data() {
    let validatePrice = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error(this.$t('friends.greaterthan')));
        // callback(new Error('Amount must be greater than 0!'));
      } else if (value >= 30) {
        if(this.form.type == '1'&&value < 50){
          
          callback(new Error('BankWithdrawal amount greater than 50 '));
        }else if(this.form.type == '2'){
          callback();
        }else if(this.form.type == '1'&&value >= 50){
          callback();
        }
      } else {
        // callback();
        callback(new Error('Withdrawal amount greater than 30 '));
      }
    };
    const comstatusOptions = [
      {
        value: "1",
        // label: "正常"
        // label: "표준"
        label: this.$t('friends.normal'),
      },
      {
        value: "0",
        // label: "无效"
        // label: "무효"
        label: this.$t('friends.invalid'),
      },
    ]
    const accountTypeOptions = [
      // 提现渠道
      // {
      //     value: "1",
      //     // label: "은행카드"
      //     // label: "bank card"
      //     label: this.$t('friends.bankcard'),
      // },
      {
        value: "1",
        label: "Bank"
      },
      {
        value: "2",
        label: "paypal"
      }
    ]
    const typeOptions = [
      {
        value: "1",
        // label: "판촉 링크"
        // label: "Promotion link"
        label: this.$t('friends.promotionlink'),
      },
      {
        value: "2",
        // label: "할인 코드"
        // label: "Discount code"
        label: this.$t('friends.discountcode'),
      },
    ]
    const statusOptions = [
      {
        value: "1",
        // label: "승인 대기 중"
        // label: "Waiting for approval"
        label: this.$t('friends.waitingforapproval'),
      },
      {
        value: "2",
        // label: "지불 대기 중"
        // label: "Waiting for payment"
        label: this.$t('friends.waitingforpayment'),
      },
      {
        value: "3",
        // label: "통과하지 못함"
        // label: "not pass"
        label: this.$t('friends.notpass'),
      },
      {
        value: "4",
        // label: "지불됨"
        // label: "Paid"
        label: this.$t('friends.paid'),
      },
    ]
    const columns = [
      {prop: 'id', label: this.$t('friends.cashwithdrawalid')},
      // { prop: 'id', label: 'Cash withdrawal ID' },
      {prop: 'account', label: this.$t('friends.accountsreceivable')},
      // { prop: 'account', label: 'Accounts receivable' },
      {prop: 'type', label: this.$t('friends.accounttype'), formatter: row => this.accountTypeState(row)},
      // { prop: 'type', label: 'account type', formatter: row => this.accountTypeState(row) },
      {prop: 'price', label: this.$t('friends.amount')},
      // { prop: 'price', label: 'Amount(USD)' },
      {prop: 'status', label: this.$t('friends.status'), formatter: row => this.statusState(row)},
      // { prop: 'status', label: 'status', formatter: row => this.statusState(row) },
      {prop: 'createTime', label: this.$t('friends.applicationtime')},
      // { prop: 'createTime', label: 'Application time' },
      {prop: 'remark', label: this.$t('friends.processingresults')},
      // { prop: 'remark', label: 'Processing results' },
    ]
    const columns1 = [
      {prop: 'orderid', label: this.$t('friends.orderid')},
      // { prop: 'orderid', label: 'order ID' },
      {prop: 'useremail', label: this.$t('friends.useramount')},
      // { prop: 'useremail', label: 'User Amount' },
      {prop: 'sku.goodsSpu.goodsname', label: this.$t('friends.sku')},
      {prop: 'sku.skuname', label: this.$t('friends.duration')},
      // { prop: 'sku.skuname', label: 'duration' },
      {prop: 'type', label: this.$t('friends.promotiontype'), formatter: row => this.typeState(row)},
      // { prop: 'type', label: 'promotion type', formatter: row => this.typeState(row) },
      // {prop: 'currency',label: '币种'},
      // { prop: 'status', label: '佣金状态', formatter: row => this.comstatusState(row) },
      {prop: 'status', label: this.$t('friends.status'), formatter: row => this.comstatusState(row)},
      {prop: 'price', label: this.$t('friends.orderamount')},
      // { prop: 'price', label: 'Order Amount(USD)' },
      {prop: 'profit', label: this.$t('friends.eainings')},
      // { prop: 'profit', label: 'Eainings(USD)' },
      {prop: 'createTime', label: this.$t('friends.createtime')},
      // { prop: 'createTime', label: 'createTime' },
    ]
    return {
      form: this.initForm(),
      dialogFormVisible: false,
      formLabelWidth: "auto",
      typeOptions,
      statusOptions,
      comstatusOptions,
      accountTypeOptions,
      tglink: false,
      discode: true,
      switchcss: true,
      activeName: 'first',
      columns,
      columns1,
      tableConfig: {
        url: '',
        dataPath: 'data.list',
        totalPath: 'data.total',
        paginationSize: 10,
        extraButtons: [
          {
            type: 'primary',
            text: 'exchange',
            icon: 'el-icon-folder-checked',
            atClick: async row => {
              this.handleExchange(row)
              return false
            },
          },
        ],
        headerButtons: [],
        hasDelete: false,
        hasEdit: false,
        hasOperation: false,
        hasNew: false,
        operationAttrs: {
          width: '100px',
          fixed: 'right',
        },
      },
      tableConfig1: {
        url: '',
        dataPath: 'data.list',
        totalPath: 'data.total',
        paginationSize: 10,
        extraButtons: [],
        headerButtons: [],
        hasDelete: false,
        hasEdit: false,
        hasOperation: false,
        hasNew: false,
        operationAttrs: {
          width: '100px',
          fixed: 'right',
        },
      },
      userinfo: "",
      userprofile: {},
      rules: {
        account: [
          // { required: true, message: '수금 계좌를 입력하십시오.', trigger: 'blur' },],
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('friends.receivingaccount'),
            trigger: 'blur'
          },],
        // { required: true, message: 'Please enter the receiving account', trigger: 'blur' },],
        price: [
          // { required: true, message: '출금 금액을 입력하십시오.', trigger: 'blur' },
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('friends.withdrawalamount'),
            trigger: 'blur'
          },
          // { required: true, message: 'Please enter the withdrawal amount', trigger: 'blur' },
          {validator: validatePrice, trigger: 'blur'},
        ],
        type: [
          // { required: true, message: '계정 유형을 입력하십시오.', trigger: 'blur' },
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('friends.accounttype'),
            trigger: 'blur'
          },
        ],
        name: [
          {
            required: true,
            // message: this.$t('home.pleaseenter') + ' ' + this.$t('friends.name'),
            message:this.$t('home.pleaseenter')+'수취인명(Beneficiary Name)',
            trigger: 'blur'
          },
        ],
        number: [
          {
            required: true,
            message: this.$t('home.pleaseenter') + '계좌번호(Beneficiary Account Number)',
            trigger: 'blur'
          },  
        ],
        bankname: [
          {
            required: true,
            message: this.$t('home.pleaseenter') + '은행 영문명(Beneficiary Bank Name)',
            trigger: 'blur'
          },
        ],
        swiftcode: [
          {
            required: true,
            message: this.$t('home.pleaseenter') + 'SWIFT CODE (Beneficiary Bank Swift Code)',
            trigger: 'blur'
          },
        ],
        // { required: true, message: 'Please enter account type', trigger: 'blur' },],
      },
      dataForm:{
        timeList:[]
      },
      amount:{
        //销售总额
        price:0,
        //收益
        profit:0
      }

    }
  },
  methods: {
    clearSmallDate(obj,objItem) {
      obj[objItem] = '';
    },
    comstatusState(row) {
      let data
      this.comstatusOptions.forEach(r => {
        if (r.value == row.status) {
          data = r.label
        }
      })
      return data
    },
    handleClick() {
      if (this.activeName === 'first') {
        this.handleTab1()
      }
      if (this.activeName === 'second') {
        this.handleTab2()
      }
    },
    toWithdrawal() {
      // if (this.userprofile.wallet <= 0) {
      //   // MessageError("현금 인출할 수 있는 금액이 없다.")
      //   // MessageError("无可提现金额")
      //   MessageError(this.$t('friends.nowithdrawableamount'))
      //   return
      // }
      this.dialogFormVisible = true
    },
    toLog() {
      this.activeName = "second"
      this.handleTab2()
    },
    closeDialog() {
      this.dialogFormVisible = false
      this.form = this.initForm();
      this.$refs.ruleUser.clearValidate();
    },
    async submitUser() {
      
      this.$refs.ruleUser.validate((valid) => {
        if (valid) {
          this.operatorUser()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async operatorUser() {
      
      if(this.form.type == '1'){
        this.form.remark = "수취인명(Beneficiary Name):" + this.form.name + ' \n' + "계좌번호(Beneficiary Account Number):" + this.form.number + ' \n' + "은행 영문명(Beneficiary Bank Name):" + this.form.bankname + ' \n' + "SWIFT CODE (Beneficiary Bank Swift Code):" + this.form.swiftcode + ' \n' + "은행 영문주소(Beneficiary Bank Address):" + this.form.address
      }
      
      this.form.userid = this.userprofile.id
      let res = await insertWithdrawal(this.form)
      if (res.status == "200") {
        MessageSuccess(res.msg)
        this.getUserByidInfo()
        this.closeDialog()
      } else {
        MessageError(res.msg)
      }
    },
    initForm() {
      return {
        userid: "", // 用户id
        account: "", // 收款账户
        price: "", // 提现金额
        type: "", // 账户类型
        status: "", // 提现状态
        operid: "", // 操作人id
        opername: "", // 操作人
        remark: "", // 备注
        name: "",
        number: "",
        bankname: "",
        swiftcode: "",
        address: "",
      }
    },
    typeState(row) {
      let data
      this.typeOptions.forEach(r => {
        if (r.value == row?.type) {
          data = r.label
        }
      })
      return data
    },
    statusState(row) {
      let data
      this.statusOptions.forEach(r => {
        if (r.value == row.status) {
          data = r.label
        }
      })
      return data
    },
    accountTypeState(row) {
      let data
      this.accountTypeOptions.forEach(r => {
        if (r.value == row?.type) {
          data = r.label
        }
      })
      return data
    },
    switchdata(val) {
      if (val == 1) {
        this.tglink = true
        this.discode = false
      } else {
        this.tglink = false
        this.discode = true
      }
    },
    copyLink(val) {
      this.$copyText(val).then(
          function (e) {
            console.log("copy arguments e:", e);
            MessageSuccess(this.$t('friends.copysuccessfully'));
            // MessageSuccess("Copy successfully!");
          },
          function (e) {
            console.log("copy arguments e:", e);
            // MessageError("복제 실패!");
            MessageSuccess(this.$t('friends.copyfailed'));
            // MessageError("Copy failed!");
          }
      );
    },
    handleExchange() {

    },
    async getUserByidInfo() {
      let res = await getUserByid(this.userinfo.id)
      if (res.status == "200") {
        this.userprofile = res.data
        this.userprofile.referrallink = "https://www.alongshare.com/?usercode=" + res.data.referrallink
      } else {
        MessageError(res.msg)
      }
    },
    handleTab1() {
      this.getUserByidInfo()
      this.$refs['promotionList'].getData(this.userinfo,this.dataForm.timeList);
      this.$refs['circlePieChart'].getData(this.dataForm.timeList);
      this.getTotalAmount();

      // this.tableConfig1.axiosConfig = {
      //     headers: {
      //         'Authorization': 'X-KILOGOD-AUTHORIZATION ' + this.$cookies.get('token'),
      //     }
      // }
      // this.tableConfig1.url = "commission/getUserById?reuserid=" + this.userinfo.id
    },
    handleTab2() {
      this.$nextTick(() => {
        this.$refs['withdrawalsList'].getData(this.userinfo);
      })
      // this.tableConfig.axiosConfig = {
      //   headers: {
      //     'Authorization': 'X-KILOGOD-AUTHORIZATION ' + this.$cookies.get('token'),
      //   }
      // }
      // this.tableConfig.url = "withdrawal/getByUserId?userid=" + this.userinfo.id
      // this.$refs.table.getList()
    },
    changeCirclePieTime(val){
      this.$refs['smallVanDateRange'].setValue([new Date(val[0]),new Date(val[1])]);
      this.$refs['circlePieChart'].getData(val);
      //orderDetails列表
      this.$refs['promotionList'].getData(this.userinfo,val)
      //统计下方金额总数
      this.getTotalAmount(val);
    },
    confirmDateRange(start,end){
      this.$set(this.dataForm,'timeList',[start,end]);
      this.$refs['circlePieChart'].getData([start,end]);
      //orderDetails列表
      this.$refs['promotionList'].getData(this.userinfo,[start,end]);
      //统计下方金额总数
      this.getTotalAmount([start,end]);
    },
    async getTotalAmount(val){
      let data = {
        starttime: val?val[0]:this.dataForm.timeList[0],
        endtime: val?val[1]:this.dataForm.timeList[1]
      }
      let res = await getkolStatisData(data);
      if(res.status=='200'){
        if(!isEmpty(res.data)){
          this.amount.price = res.data.price||0;
          this.amount.profit = res.data.profit||0;
        }
      }
    },
  },
  async mounted() {
    let userInfo = getUserInfo()
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
      let startDate = new Date(this.$moment());
      let endDate = new Date(this.$moment(startDate).add(30, 'day'));
      this.$set(this.dataForm,'timeList',[startDate,endDate]);
      this.$refs['smallVanDateRange'].setValue([new Date(startDate),new Date(endDate)]);
      this.handleTab1()
    }
  }
}
</script>

<style lang="scss" scoped>
.total-amount{
  display:flex;
  justify-content: center;
  div{
    font-weight:bold;
    font-size:20px;
    margin-right:30px;
  }
}

.cardall {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 40px 0 40px 0;
  @media (max-width:992px) {
    margin-bottom:0!important;
  }
}

.tabs {
  width: 100%;
  background-color: #ffffff;
  //margin: 30px;
  border-radius: 5px;
}

::v-deep .el-tabs__header {
  margin-bottom: 0;
}

::v-deep .el-tabs__item {
  font-weight: border;
}


.img1 {
  position: relative;
  width: 24%;
  margin-right: 30px;
  //background-image: url(https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/friends-grade.png);
  //background-size: cover;
  //background-repeat: no-repeat;
  border-radius: 7px;
  font-size: 30px;
  font-weight: bold;
  @media (max-width:992px) {
    width: 100%;
    margin-bottom:30px;
  }

  ::v-deep .el-card__body {
    height: 100%;
  }

  &-amount {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    padding: 0 24px;
    word-break: break-word;
    text-align: center;
  }
}

.img2 {
  width: 24%;
  margin-right: 30px;
  font-size: 15px;
  //margin-left: 2%;
  //background-image: url(https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/friends-extend.png);
  //background-size: cover;
  //background-repeat: no-repeat;
  border-radius: 7px;
  @media (max-width:992px) {
    width: 100%;
    margin-bottom:30px;
  }

  ::v-deep .el-card__body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  &-discountratio {
    margin-left: 10px;
    font-weight: bold;
    font-size: 26px;
  }

  &-discount {
    font-weight: bold;
  }

  &-code {
    font-size: 30px;
    font-weight: bold;
    word-break: break-word;
    text-align: center;
  }

  &-ratio {
    text-align: right;
  }
}

.img3 {
  flex: 1;
  //width: 32%;
  //margin-left: 2%;
  //background-image: url(https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/friends-wallet.png);
  //background-size: cover;
  //background-repeat: no-repeat;
  border-radius: 7px;
  @media (max-width:992px) {
    width:100%;
    flex:revert;
    margin-bottom:30px;
  }
}

.friends-bottom {
  display: flex;
  flex-wrap: wrap;
  margin-bottom:50px;
  @media (max-width:598.98px) {
    margin-bottom:0;
  }
  &-title {
    font-size: 20px;
  }

  ::v-deep .el-card {
    width: calc(100% / 2);

    &:not(:last-child) {
      margin-right: 30px;
    }
    @media (max-width:992px) {
      width:100%;
      margin-right:0;
      margin-bottom:30px;
    }
  }

  .circle-pie {
    flex: 1;
    ::v-deep .el-card__body{
      height:100%;
    }
  }
}

.gradedesc {
  height: 20%;
  position: relative;
  background-color: #2A8658;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  display: flex;
  justify-content: center;
}

.gradetext {
  font-size: 12px;
  flex-wrap: wrap;
  color: white;
  margin-top: 2%;
}

.link {
  color: #000;
  //background-color: #ffffff;
  font-size: 40px;
  font-weight: bold;
  border-radius: 2px;
  word-break: normal;
  word-wrap: normal;
  white-space: pre-wrap;
}

.dashed {
  width: 2px;
  height: 130px;
  background-image: linear-gradient(to bottom, #ffffff 0%, #39B979 50%, transparent 30%);
  background-size: 8px 8px;
  background-repeat: repeat-y;
}

::v-deep .customWidth {
  width: 50%;

  .withdrawal-amount{
    span{
      border-radius: 10px;
    }
    .el-input__inner{
      height:40px;
    }
  }
  .dialog-footer{
    display: flex;
    align-items: center;
    justify-content: space-around;
    button{
      width: 30%;
      margin-left: 0;
      margin-top: 10px;
    }
  }

}


.highlight {
  font-size: 15px;
  font-weight: bolder;
  cursor: pointer;
}

.obscurity {
  font-size: 15px;
  color: #000;
  cursor: pointer
}

::v-deep .el-card {
  min-height:280px;
  &__body {
    height:100%;
    //min-height: 280px;
  }

}
::v-deep .el-range-editor.el-input__inner{
  @media (max-width:768px) {
    width:100% !important;
    margin-bottom:40px!important;
  }
}

::v-deep .chart-box{
  @media (max-width:598.98px) {
    height:revert;
  }
}
</style>
